import {
  Checkbox,
  InputText,
  Toast,
} from '@fattureincloud/fic-design-system'
import { InputHelperProps } from '@fattureincloud/fic-design-system/dist/components/form/inputHelper'
import React, { FC, useEffect, useState } from 'react'

import { httpRequest } from '../../common/network'
import { getIcon } from '../../common/utils'
import { errorMessage, locale } from '../../locales/locale'
import { useAppSelector } from '../../redux/hooks'
import { HelpModal, SectionIcon } from '../common.components'
import { FieldEditRow } from './dnd.components'

interface Props {
  onClose: () => void
  parentSectionId: number
  onSuccess: () => void
}

const AddSectionModal: FC<Props> = (props: Props) => {
  const [newTitle, setNewTitle] = useState<string>('')
  const [icon, setIcon] = useState<string>('')
  const [description, setDescription] = useState<string>('')
  const [helper, setHelper] = useState<InputHelperProps>(undefined)
  const [visCompany, setVisCompany] = useState<boolean>(false)
  const [visAccountant, setVisAccountant] = useState<boolean>(false)
  const realm = useAppSelector((state) => state.realm.value)
  const isSubSection = props.parentSectionId !== null
  const defaultHelper = {
    message: isSubSection
      ? locale('La sottosezione avrà come parent section la sezione con ID:') + ' ' +
      String(props.parentSectionId)
      : locale('La sezione comparirà nella pagina principale'),
    status: 'info',
  }

  useEffect(() => {
    setHelper(defaultHelper)
  }, [])

  const checkTitleError = () => {
    if (newTitle.length === 0) {
      setHelper({ message: locale('Inserisci un titolo'), status: 'error' })
      return true
    }
    setHelper(defaultHelper)
    return false
  }

  const addSubSubSection = () => {
    const error = checkTitleError()

    if (error) return
    httpRequest({
      method: 'POST',
      path: 'help/sections',
      data: {
        title: newTitle,
        realm: realm,
        icon: icon,
        parent_section: props.parentSectionId,
        vis_company: visCompany ? 1 : 0,
        vis_accountant: visAccountant ? 1 : 0,
        description: description,
      },
      onSuccess: () => {
        Toast.success(
          isSubSection ? locale('Sottosezione') + locale(' inserita') : locale('Sezione') + locale(' inserita')
        )
        props.onSuccess()
      },
      onError: (res) => {
        Toast.error(errorMessage, { content: res.message })
      },
    })
  }

  return (
    <HelpModal
      title={locale('Aggiungi ') + (isSubSection ? locale('Sottosezione') : locale('Sezione'))}
      onActionClose={props.onClose}
      footerButtons={[
        { text: locale('Salva'), color: 'green', onClick: addSubSubSection },
      ]}
    >
      <InputText
        value={newTitle}
        label={locale('Titolo')}
        onChange={(e) => setNewTitle(e.target.value)}
        helper={helper}
      />
      <FieldEditRow>
        {realm !== 'resellers' &&
          <>
            <Checkbox
              value={visCompany}
              text={locale('Visibile Aziende')}
              onChange={() => setVisCompany(!visCompany)}
            />
            <Checkbox
              value={visAccountant}
              text={locale('Visibile Commercialisti')}
              onChange={() => setVisAccountant(!visAccountant)}
            />
          </>
        }
        {!isSubSection && (
          <>
            <InputText
              label={locale('Icona')}
              value={icon}
              onChange={(e) => setIcon(e.target.value)}
            />
            <SectionIcon icon={getIcon(icon)} />
          </>
        )}
      </FieldEditRow>
      {!isSubSection && (
        <FieldEditRow>
          <InputText
            label={locale('Descrizione')}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FieldEditRow>
      )}
    </HelpModal>
  )
}

export default AddSectionModal
